import { getElectronAPI } from "./electron";

export async function getElectronConfigSafe() {
  const api = getElectronAPI();
  if (!api) return null;

  try {
    return await api.getConfig();
  } catch {
    return null;
  }
}

export async function setElectronSelectedPrinterId(
  selectedPrinterId: number | null,
) {
  const api = getElectronAPI();
  if (!api) {
    throw new Error("Electron API not available");
  }

  await api.setSelectedPrinterId(selectedPrinterId);
}
